import SitemapService from '../app/runtime/services/SitemapService';

export default async (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').before('[[[Bezpieczeństwo]]]', [
        {
            name: '[[[Konta użytkowników]]]',
            route: 'studio-accounts',
            icon: 'far fa-fw fa-users',
            auth: { all: ['AdminPermissions@Accounts'], any: [] }
        }
    ]);

    sitemap.after('[[[System]]]', [
        {
            name: '[[[Design Studio]]] (β)',
            short: '[[[Studio]]]',
            icon: 'fa-light fa-circle-nodes',
            namespace: 'Ideo.Core.Common.Application.Permissions.Studio',
            children: [
                {
                    name: '[[[Formularze]]]',
                    icon: 'far fa-fw fa-table-layout',
                    children: [
                        {
                            name: '[[[Definicje]]]',
                            auth: { all: ['FormsPermissions@Access'], any: [] },
                            route: 'studio-forms',
                            children: [
                                {
                                    name: '[[[Edycja definicji]]]',
                                    route: 'studio-forms-edit',
                                    auth: { all: [], any: ['FormsPermissions@Edit', 'FormsPermissions@EditAll'] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Kategorie]]]',
                            auth: { all: ['FormsPermissions@Access'], any: [] },
                            route: 'studio-forms-categories'
                        }
                    ]
                },
                {
                    name: '[[[Komponenty]]]',
                    icon: 'far fa-fw fa-grid-round-2-plus',
                    auth: { all: ['ComponentsPermissions@Access'], any: [] },
                    route: 'studio-components',
                    children: [
                        {
                            name: '[[[Dodanie komponentu]]]',
                            route: 'studio-components-add',
                            auth: { all: ['ComponentsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja komponentu]]]',
                            route: 'studio-components-edit',
                            auth: { all: ['ComponentsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Źródła danych]]]',
                    route: 'studio-datasources',
                    icon: 'far fa-fw fa-database',
                    auth: { all: ['DataSourcesPermissions@Access'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie źródła danych]]]',
                            route: 'studio-datasources-add',
                            auth: { all: ['DataSourcesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja źródła danych]]]',
                            route: 'studio-datasources-edit',
                            auth: { all: ['DataSourcesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Moduły]]]',
                    icon: 'far fa-fw fa-layer-group',
                    auth: { all: ['ModulesPermissions@Access'], any: [] },
                    route: 'studio-modules',
                    children: [
                        {
                            name: '[[[Dodanie modułu]]]',
                            route: 'studio-modules-add',
                            auth: { all: ['ModulesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja modułu]]]',
                            route: 'studio-modules-edit',
                            auth: { all: ['ModulesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[RESTful API]]]',
                    icon: 'far fa-fw fa-brackets-curly',
                    auth: { all: ['EndpointsPermissions@Access'], any: [] },
                    route: 'studio-endpoints',
                    children: [
                        {
                            name: '[[[Dodanie endpointu]]]',
                            route: 'studio-endpoints-add',
                            auth: { all: ['EndpointsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja endpointu]]]',
                            route: 'studio-endpoints-edit',
                            auth: { all: ['EndpointsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Webhooki]]]',
                    icon: 'far fa-fw fa-webhook',
                    auth: { all: ['WebhooksPermissions@Access'], any: [] },
                    route: 'studio-webhooks',
                    children: [
                        {
                            name: '[[[Dodanie webhooka]]]',
                            route: 'studio-webhooks-add',
                            auth: { all: ['WebhooksPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja webhooka]]]',
                            route: 'studio-webhooks-edit',
                            auth: { all: ['WebhooksPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Logi]]]',
                            route: 'studio-webhooks-logs',
                            auth: { all: ['WebhooksPermissions@Access'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Automatyzacja]]]',
                    icon: 'far fa-fw fa-gears', // fa-braille
                    auth: { all: ['AutomationsPermissions@Access'], any: [] },
                    url: '#',
                    route: 'studio-automations',
                    children: [
                        {
                            name: '[[[Edycja scenariusza]]]',
                            route: 'studio-automations-edit',
                            auth: { all: ['AutomationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Historia]]]',
                            route: 'studio-automations-processes',
                            auth: { all: ['AutomationsPermissions@Edit'], any: [] },
                            visible: false,
                            children: [
                                {
                                    name: '[[[Proces]]]',
                                    route: 'studio-automations-stages',
                                    auth: { all: ['AutomationsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Moduły]]]',
            short: '[[[Moduły]]]',
            icon: 'fa-light fa-layer-group',
            route: 'studio-docs',
            auth: { all: ['ModulesPermissions@Access'], any: [] },
            preventCloseMenu: true
        }
    ]);

    await sitemap.find('[[[Moduły]]]').updateAsync(async node => await updateSitemap(node));
};

async function updateSitemap(root: SitemapNode)
{
    const { $log } = useLogging();

    try
    {
        const response = await SitemapService.getSitemap();
        const children = response.map((m) =>
        {
            let module: SitemapNode = {
                name: m.name,
                icon: `far fa-fw ${m.icon}`,
                auth: { any: [], all: [] },
                visible: !m.isHidden,
                allowed: true
            };

            const sections: SitemapNode[] = m.nodes.filter(sectionNode => !sectionNode.isHidden).map((s, i) =>
            {
                const section: SitemapNode = {
                    name: s.name,
                    route: 'studio-docs-main',
                    routeParams: {
                        module: m.symbol,
                        section: s.symbol
                    },
                    icon: `far fa-fw ${s.icon}`,
                    auth: { any: [], all: [] },
                    visible: !s.isHidden,
                    allowed: true,
                    children: [],
                    virtual: true
                };

                if (s.template != 'Settings')
                {
                    section.children = [
                        {
                            name: $t('[[[Dodaj wpis]]]'),
                            route: 'studio-docs-add',
                            routeParams: {
                                module: m.symbol,
                                section: s.symbol
                            },
                            auth: { any: [], all: [] },
                            visible: false,
                            allowed: true,
                            children: [],
                            virtual: true
                        },
                        {
                            name: $t('[[[Edytuj wpis]]]'),
                            route: 'studio-docs-edit',
                            routeParams: {
                                module: m.symbol,
                                section: s.symbol
                            },
                            auth: { any: [], all: [] },
                            visible: false,
                            allowed: true,
                            children: [],
                            virtual: true
                        }
                    ];
                }

                return section;
            });

            if (sections.length == 1)
            {
                module = { ...sections[0], ...module };
            }
            else
            {
                module.children = sections;
            }

            return module;
        });

        root.children = root.children || [];
        root.children = [...root.children, ...children];
    }
    catch (ex)
    {
        handleException($log, ex);
    }
}
